/**
 * 付款弹框
 */
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './PayModal.module.scss';
import http from '@/assets/api/http';
import { Modal, message, Form, Input, Select } from 'antd';
import { TableActionType as ta } from '@/util/enum';
import { priceUppercase, toThousands, regFenToYuan } from '@/util/money';
import * as apis from '@/apis/finance/platformAccount';


const layout = {
    labelCol: {
        span: 6
    }
};

const InfoModal = (props) => {

    const [confirmLoading, setConfirmLoading] = useState(false);
    const [form] = Form.useForm();

    const [merchantsList, setMerchantsList] = useState([]);  // 服务商列表

    useEffect(() => {
        if (props.type === ta.edit) {
            const { ...fields } = props.data;
            form.setFieldsValue({
                ...fields
            });
        }

        getServiceMerchants();
    }, []);

    // 身边云代付账户-服务商列表
    const getServiceMerchants = ()=>{
        apis.getYoufuServiceMerchants().then(res=>{
            setMerchantsList(res.result);
            form.setFieldsValue({levyId: res.result[0].code});
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const _handleOk = () => {
        const { data } = props;
        form.validateFields().then(fields => {
            setConfirmLoading(true);
            http('/?cmd=com.xqxc.api.pig.mis.pay.WithdrawalMisService.paymentApplicationConfirm', {
                paymentApplicationId: data.id,
                ...fields
            }, 'POST').then(() => {
                message.success('提交成功');
                setConfirmLoading(false);
                props.closeMode && props.closeMode(true);
            }).catch((e = {}) => {
                message.success(e.message || '提交异常');
                setConfirmLoading(false)
                props.closeMode && props.closeMode();
            });
        });
    }

    const _handleCancel = () => {
        props.closeMode && props.closeMode();
    }

    const { id, amount } = props.data;

    let yuan = regFenToYuan(amount);
    let up = priceUppercase(yuan);
    let th = toThousands(yuan);

    return (
        <Modal
            width={520}
            centered
            title={props.title}
            visible={props.visible}
            confirmLoading={confirmLoading}
            onOk={_handleOk}
            onCancel={_handleCancel}
            destroyOnClose={true}
            keyboard={true}
            maskClosable={false}
            cancelText='取消'
            okText='确认'
        >
            <Form {...layout} className={styles.container} form={form} labelAlign='left'>
                <Form.Item label="付款单号">{id}</Form.Item>
                <Form.Item label="合计转账金额">
                    <span>{th}（{up}）</span>
                </Form.Item>
                <Form.Item label="服务商" name="levyId" rules={[{ required: true, message: '请选择服务商' }]}>
                    <Select style={{ width: '100%' }}>
                        {merchantsList.map(item => <Select.Option key={item.code} value={item.code} >{item.name}</Select.Option>)}
                    </Select>
                </Form.Item>
                <Form.Item label="财务密码" name="password" rules={[{ required: true, message: '请输入财务密码' }]}>
                    <Input.Password placeholder='请输入' />
                </Form.Item>
                <Form.Item label="备注" name="remark">
                    <Input.TextArea placeholder='请输入' />
                </Form.Item>
            </Form>
            <div style={{ color: '#808080' }}>提示：确认后付款完成</div>
        </Modal>
    );

}

InfoModal.propTypes = {
    positionList: PropTypes.array,
    data: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object
    ]), // 弹框入参
    visible: PropTypes.bool.isRequired, // 是否显示弹框
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string,// 弹框标题
    type: PropTypes.string,
    curTabID: PropTypes.string,
};

export default InfoModal;